import {Fragment, h, JSX} from 'preact'
import classNames from 'classnames'
import {ComplimentaryColor} from '../../types/types'
import {PlusIcon} from './Icons';

export interface ProductButtonProps {
    title: string;
    price: string;
    color?: ComplimentaryColor;
    active: boolean;
}

export interface ProductButtonGridProps {
    title: string;
    name: string;
    products: (ProductButtonProps | undefined)[][];
    renderEmptyCards?: boolean;
    onClick?: (row: number, col: number) => void;
    onDrag?: (row1: number, col1: number, row2: number, col2: number) => void;
    onDragStart?: (row: number, col: number) => void;
    dragCurrentRow?: number;
    dragTargetCol?: number;
}

export const ProductButtonGrid = (props: ProductButtonGridProps): JSX.Element => (
    <Fragment>
        <div class='flex flex-col gap-2'>
            {props.products.map((productRow, row) => (
                <div class='flex -mx-1'>
                    {productRow.map((product, col) => (
                        <div
                            class='basis-1/6 grow-0 shrink-0 overflow-hidden px-1'
                            onDragOver={(e) => {
                                if (props.onDrag) {
                                    e.preventDefault()
                                }
                            }}
                            onDrop={(e) => {
                                if (props.onDrag) {
                                    props.onDrag(props.dragCurrentRow, props.dragTargetCol, row, col)
                                }
                            }}
                        >
                            {product && (
                                <button
                                    draggable={!!props.onDrag && product.active}
                                    onDragStart={() => {
                                        if (props.onDrag) {
                                            props.onDragStart(row, col)
                                        }
                                    }}
                                    onClick={() => {
                                        if (props.onClick) {
                                            props.onClick(row, col);
                                        }
                                    }}
                                    className={classNames(
                                        'h-[120px] rounded-base flex flex-col justify-between p-3 w-full transition-opacity',
                                        'bg-kinola-complimentary-' + product.color,
                                        ['dark-blue', 'dark-red'].includes(product.color) && 'text-white',
                                        product.active && 'cursor-pointer hover:opacity-70',
                                        !product.active && !props.onDragStart && 'cursor-not-allowed opacity-50',
                                        !product.active && props.onDragStart && 'opacity-50 hover:opacity-70',
                                    )}
                                >
                                    <span className={classNames(
                                        'self-start text-left overflow-ellipsis overflow-hidden w-full',
                                        !product.active && 'line-through'
                                    )}>{product.title}</span>
                                    <span class="self-end text-right">{product.price}</span>
                                </button>
                            )}
                            {props.renderEmptyCards && !product && (
                                <button
                                    draggable={!!props.onDrag}
                                    onDragStart={() => {
                                        if (props.onDrag) {
                                            props.onDragStart(row, col)
                                        }
                                    }}
                                    onClick={() => {
                                        if (props.onClick) {
                                            props.onClick(row, col);
                                        }
                                    }}
                                    className={classNames(
                                        'group h-[120px] rounded-base flex flex-col justify-between p-3 w-full hover:opacity-70 transition-opacity bg-gray-100 cursor-pointer',
                                    )}
                                >
                                    <PlusIcon
                                        class='w-10 h-10 m-auto text-gray-300 group-hover:text-black transition-colors'
                                    />
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    </Fragment>
)
